import { c as _c } from "react/compiler-runtime";
import { AmountPicker } from '@7f-ui/components/inputs_old/amount-picker';
import { Price } from '@7f-ui/components/price';
import type { NexperienceVariantOption } from '@data-access/graphql/schema.types';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { useState } from 'react';
import { useExperiencePriceCategoryName } from '../_hooks/use-app-experience-price-category-name';
import { getTotalCount, resolveMaxCapacity } from '../_lib/experience-booking-utils';
import type { SelectedOptions } from '../_lib/experience-state-types';
import { useExperienceFilterContext } from './app-experience-filter-provider';
type PersonSelectProps = {
  selectedOptions: SelectedOptions | null;
  variantId: string;
  options: NexperienceVariantOption[];
  priceCategory: string | null | undefined;
  onChange: (data: {
    selectedOptions: SelectedOptions | null;
  }) => void;
};
export function AppPersonSelect(t0) {
  const $ = _c(22);
  const {
    variantId,
    selectedOptions: initialSelectedOptions,
    options,
    priceCategory,
    onChange
  } = t0;
  let t1;
  if ($[0] !== initialSelectedOptions || $[1] !== variantId) {
    t1 = variantId ? {
      [variantId]: initialSelectedOptions
    } : {};
    $[0] = initialSelectedOptions;
    $[1] = variantId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [selectedOptions, setSelectedOptions] = useState(t1);
  const {
    variants
  } = useExperienceFilterContext();
  let t2;
  if ($[3] !== variantId || $[4] !== variants) {
    let t3;
    if ($[6] !== variantId) {
      t3 = variant => variant.id === variantId;
      $[6] = variantId;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    const selectedVariant = variants.find(t3);
    t2 = resolveMaxCapacity(selectedVariant?.maxCapacity);
    $[3] = variantId;
    $[4] = variants;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const maxCapacity = t2;
  let t3;
  if ($[8] !== onChange || $[9] !== selectedOptions || $[10] !== variantId) {
    t3 = (optionId, count) => {
      const updatedOptions = {
        ...selectedOptions[variantId],
        [optionId]: count
      };
      if (count === 0) {
        delete updatedOptions[optionId];
      }
      setSelectedOptions({
        ...selectedOptions,
        [variantId]: updatedOptions
      });
      onChange({
        selectedOptions: updatedOptions
      });
    };
    $[8] = onChange;
    $[9] = selectedOptions;
    $[10] = variantId;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const onOptionChange = t3;
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = shopTestId("PersonSelect.item");
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== maxCapacity || $[14] !== onOptionChange || $[15] !== options || $[16] !== priceCategory || $[17] !== selectedOptions || $[18] !== variantId) {
    t5 = options.map(option => {
      const totalCount = getTotalCount(variantId ? selectedOptions[variantId] : null, options);
      return <OptionPicker key={option.id} maxCapacity={resolveMaxCapacity(option.max)} minCapacity={option.min} priceCategory={priceCategory} currentCount={selectedOptions[variantId]?.[option.id] ?? 0} onChange={count_0 => onOptionChange(option.id, count_0)} willExceedCapacity={totalCount + option.groupSize > maxCapacity || option.min === option.max && totalCount > 0} {...option} />;
    });
    $[13] = maxCapacity;
    $[14] = onOptionChange;
    $[15] = options;
    $[16] = priceCategory;
    $[17] = selectedOptions;
    $[18] = variantId;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t5) {
    t6 = <div className="flex flex-col gap-6" data-testid={t4}>{t5}</div>;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}
type OptionPickerProps = NexperienceVariantOption & {
  maxCapacity: number;
  minCapacity: number;
  currentCount: number;
  groupSize: number;
  willExceedCapacity: boolean;
  priceCategory: string | null | undefined;
  onChange: (count: number) => void;
};
const OptionPicker = t0 => {
  const $ = _c(44);
  const {
    name,
    price,
    currency,
    description,
    maxCapacity,
    minCapacity,
    currentCount,
    groupSize,
    priceCategory,
    willExceedCapacity,
    onChange
  } = t0;
  const getExperiencePriceCategoryName = useExperiencePriceCategoryName();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = shopTestId("PersonSelect.option");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== getExperiencePriceCategoryName || $[2] !== name) {
    t2 = getExperiencePriceCategoryName(name);
    $[1] = getExperiencePriceCategoryName;
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h5 className="font-heading5">{t2}</h5>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== groupSize) {
    t4 = groupSize > 1 && <p>{`für ${groupSize} Personen`}</p>;
    $[6] = groupSize;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== description) {
    t5 = description && <p>{description}</p>;
    $[8] = description;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== minCapacity) {
    t6 = minCapacity > 0 && <p>{`Die Mindestanzahl beträgt ${minCapacity}.`}</p>;
    $[10] = minCapacity;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className="max-w-96 font-body-small">{t4}{t5}{t6}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t7) {
    t8 = <div className="flex flex-col justify-center">{t3}{t7}</div>;
    $[16] = t3;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="sm:grow" />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== currency || $[21] !== price) {
    t10 = <Price amount={price} currency={currency} />;
    $[20] = currency;
    $[21] = price;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== getExperiencePriceCategoryName || $[24] !== groupSize || $[25] !== name || $[26] !== priceCategory) {
    t11 = groupSize === 1 ? getExperiencePriceCategoryName(priceCategory === "Ticket" ? "ticket" : "persons") : getExperiencePriceCategoryName(name);
    $[23] = getExperiencePriceCategoryName;
    $[24] = groupSize;
    $[25] = name;
    $[26] = priceCategory;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11) {
    t12 = <div className="mt-1 content-center font-body-small sm:mt-0">{t10}{" / "}{t11}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t8) {
    t13 = <div className="flex w-full flex-col sm:flex-row sm:gap-6" data-testid={t1}>{t8}{t9}{t12}</div>;
    $[31] = t12;
    $[32] = t8;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const t14 = currentCount <= 0;
  const t15 = willExceedCapacity || currentCount >= maxCapacity;
  const t16 = maxCapacity === minCapacity ? maxCapacity : undefined;
  const t17 = minCapacity || 1;
  let t18;
  if ($[34] !== currentCount || $[35] !== onChange || $[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t17) {
    t18 = <AmountPicker value={currentCount} onChange={onChange} decreaseDisabled={t14} increaseDisabled={t15} fixedValue={t16} initialStep={t17} />;
    $[34] = currentCount;
    $[35] = onChange;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t13 || $[42] !== t18) {
    t19 = <div className="mb-6 flex flex-col sm:mb-0"><div className="flex gap-6">{t13}{t18}</div></div>;
    $[41] = t13;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  return t19;
};